import MyService from '../../service';

const CityApi = {
  getAll: async () => {
    let cities = [];
    await MyService.getRequestData('/partners/cities')
      .then((result) => (cities = result.data))
      .catch((err) => console.log(err));
    return cities;
  },
  getById: async (city_id) => {
    let cities = null;
    console.log('city id ', city_id);
    await MyService.getRequestData('/partners/cities/getById', { city_id })
      .then((result) => {
        cities = result.data;
      })
      .catch((err) => console.log(err));
    return cities;
  },
  create: async (book) => {
    let booking;
    console.log('book ', book);
    await MyService.postRequestData('/partners/cities/create', book)
      .then((result) => {
        booking = result;
      })
      .catch((err) => console.log(err));

    return booking;
  },
  deleteCity: async (id) => {
    let result = null;
    result = await MyService.postRequestData('/partners/cities/delete', {
      city_id: id,
    });

    return result;
  },
  update: async (partner) => {
    console.log('update ', partner);
    const resultCreate = await MyService.postRequestData(
      '/partners/cities/update',
      partner
    );
    return resultCreate;
  },
};

export default CityApi;
